<template>
  <div style="height: 100%">
    <div v-show="show" style="height: 100%">
      <keep-alive >
        <router-view  v-if="keepAlive"/>
      </keep-alive>
      <router-view v-if="!keepAlive" />
    </div>
    <div v-if="!show"> 当前没有选择项目，请选择项目进行操作</div>
  </div>
</template>

<script>
import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
import Vue from 'vue'
import { getAction } from '@/api/manage'
import { mapGetters } from 'vuex'
export default {
  name: 'ProjectRouteView',
  inject:['changeProjectName'],
  data(){
    return {
      show:false,
      projectId:Vue.ls.get(CACHE_PROJECT_ID) || '',
      projectName:Vue.ls.get(CACHE_PROJECT_NAME) || '',
      adminRole:window._CONFIG.adminRole,
      userRoles:[]
    }
  },
  computed:{
    keepAlive () {
      return this.$route.meta.keepAlive
    }
  },
  mounted(){
    // sessionStorage.setItem()
    console.log("projectRouteView,this.projectId:"+ this.projectId)
    if(this.projectId){
      this.changeProjectName(this.projectName)
      this.show = true
    }else{
      // this.show = false
      //  管理员不需要跳转
      getAction('/sys/api/getUserRoleSet',{username:this.userInfo().username}).then(res=>{
        this.userRoles = res
        if(!(this.includes(this.adminRole,this.userRoles).length>0)){
          this.$router.push({path:'/index'})
        }
      })
      // this.$router.push({path:'/?redirect='+this.$route.path})
    }
  },
  methods:{
    ...mapGetters(["userInfo"]),
    includes(arr1,arr2){
      return arr1.filter(item=>{
        return arr2.includes(item)
      })
    },
  }
}
</script>

<style scoped>

</style>
